import { create } from 'apisauce'
import store from '../../store'
import handleNetworkError from '../../actions/network'
import { logout } from '../../actions/application'
import { setDriverNotFound } from '../../screens/NewDriver/actions'

const baseURL = 'https://api.cpfcnpj.com.br'
const apiPrd = create({
  baseURL,
  headers: {},
  timeout: 8000,
})

apiPrd.axiosInstance.interceptors.request.use(
  (config) => {
    const newConfig = {
      ...config,
    }
    return newConfig
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  },
)


// apiPrd.addResponseTransform((response) => {
//   console.log(JSON.stringify(response))
// })

apiPrd.axiosInstance.interceptors.response.use(
  response => (
    response
  ), error => (
    new Promise(() => {
      if (error.response) {
        const statusCode = error.response.status
        if (statusCode === 401) {
          // call to login
          return store.dispatch(logout())
        } else if (statusCode === 403) {
          // return store.dispatch(refreshUserToken())
        }
        store.dispatch(setDriverNotFound())
        return store.dispatch(handleNetworkError(error.response.status, error.response.data))
      } else if (error.code === 'ECONNABORTED') {
        return store.dispatch(setDriverNotFound())
      }
      return store.dispatch(handleNetworkError(500))
    })
  ))

apiPrd.axiosInstance.interceptors.request.use((config) => {
  return config
}, (error) => {
  console.log(error)
  return Promise.reject(error)
})
export default apiPrd
